var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2022(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#000aff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_20px_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    className: "cls-2",
    d: "M37.08,120c-13.61,0-21.43,0-29.26-7.82C0,104.35,0,96.53,0,82.92V37.08C0,23.47,0,15.65,7.82,7.82,15.65,0,23.47,0,37.08,0h45.83c13.61,0,21.43,0,29.26,7.82,7.82,7.82,7.82,15.65,7.82,29.26v45.83c0,13.61,0,21.43-7.82,29.26-7.82,7.82-15.65,7.82-29.26,7.82H37.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.53,42.71c-2.22,.6-5.14,1.31-5.14,4.64v26.22c0,2.82,2.92,3.43,4.59,3.78v2.32h-16.28v-2.42c2.27-.56,4.59-.96,4.59-3.83v-26.67l-11.6,32.92h-2.77l-11.45-33.58v27.13c0,2.57,2.62,3.78,4.59,4.13v2.32h-13.92v-2.37c2.02-.5,4.94-1.26,4.94-4.18v-25.31c0-3.03-3.43-4.74-5.34-5.09v-2.37h15.43l8.77,25.76,9.18-25.76h14.42v2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.62,45.58h-2.52v-2.62h-2.63v-2.62h31.38v2.59h5.2v5.21h2.65v5.28h2.63v10.41h-2.6v7.85h-2.65v2.64h-2.57v2.56h-2.64v2.63H13.47v-2.6h2.62v-2.56h2.53v-28.76Zm7.9,31.29h13.14v-2.55h2.57v-2.64h2.6v-23.54h-2.62v-2.56h-2.57v-2.59h-13.11v33.89Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2022);
export default __webpack_public_path__ + "static/media/logo_2022.a0c8511cb6816a1f1b5863709337f6bb.svg";
export { ForwardRef as ReactComponent };